import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
export default {
  data () {
    return {
      customerInfo: '',
      pageNum: 1,
      pageSize: 6
    }
  },
  computed: {
    ...mapState('certificationAuditModule', ['memberInfoData'])
  },
  methods: {
    ...mapActions('certificationAuditModule', ['searchCustomerByCondition']),
    pageSizeChange () {
      this.pageSize = this.pageSize + 3
      this.searchCustomer()
    },
    searchCustomer () {
      if (!this.customerInfo) {
        return
      }
      let data = {
        allInfo: this.customerInfo,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.searchCustomerByCondition(data)
    },
    skipToCustomerDetail (item) {
      this.$router.push({
        path: RoutePathConstants.CERTIFICATION_DETAIL,
        query: {
          item: JSON.stringify(item)
        }
      })
    }
  },
  mounted () {
    // this.searchCustomer()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/views/certification-audit-view.js